import React from "react";
import { motion } from "framer-motion";

const About = () => {
  const services = [
    { title: "AI Agents", description: "Intelligent AI-powered virtual agents.", image: "/assets/img2.jpg" },
    { title: "Chatbots", description: "Engage with automated AI-driven responses.", image: "/assets/explore.webp" },
    { title: "Face Recognition", description: "Advanced AI for facial analysis.", image: "/assets/img1.webp" },
    { title: "OCR", description: "Extract text from images and scanned documents.", image: "/assets/img3.jpg" },
    { title: "Language Translation", description: "Seamless multilingual translations powered by AI.", image: "/assets/img4.jpg" },
    { title: "Sentiment Analysis", description: "Analyze emotions in text and user interactions.", image: "/assets/img7.avif" },
  ];

  return (
    <div className="bg-black text-white min-h-screen">
      <section className="text-center py-16 md:py-24 px-6">
        <motion.h1
          className="text-4xl md:text-5xl"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          About
        </motion.h1>
        <motion.p
          className="mt-6 text-lg text-gray-300 max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          neUro Ki is a one-stop AI utility platform offering powerful tools for automation, data analysis, and AI-driven solutions. From chatbots to deep learning models, it simplifies AI for enhanced productivity and innovation.
        </motion.p>
      </section>

      {/* About Content Section */}
      <section className="container mx-auto px-6 md:px-16 py-16 md:py-24 flex flex-col space-y-16">
        {/* First Block: Text Left, Image Right */}
        <div className="flex flex-col md:flex-row items-center justify-between space-y-12 md:space-y-0">
          <motion.div
            className="md:w-1/2 pr-6"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <h3 className="text-3xl md:text-4xl">Our Vision for AI</h3>
            <p className="mt-6 text-lg text-gray-300">
              Our mission is to make AI accessible and impactful for everyone. We develop intelligent systems that enhance productivity, align with human values, and drive innovation across industries.
            </p>
          </motion.div>

          {/* Responsive Increased Image */}
          <motion.div
            className="md:w-1/2 h-[450px] md:h-[600px] rounded-3xl overflow-hidden shadow-xl"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <img src="/assets/explore.webp" alt="AI Vision" className="w-full h-full object-cover" />
          </motion.div>
        </div>

        {/* Second Block: Image Left, Text Right */}
        <div className="flex flex-col-reverse md:flex-row items-center justify-between space-y-12 md:space-y-0 md:space-x-12">
          <motion.div
            className="md:w-1/2 h-[450px] md:h-[600px] rounded-3xl overflow-hidden shadow-xl"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <img src="/assets/img2.jpg" alt="AI Innovation" className="w-full h-full object-cover" />
          </motion.div>

          <motion.div
            className="md:w-1/2 pl-6"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <h3 className="text-3xl md:text-4xl">AI’s Impact on Industries</h3>
            <p className="mt-6 text-lg text-gray-300">
              AI is transforming industries by automating tasks, enhancing decision-making, and improving customer experiences. At neUro Ki, we create cutting-edge AI solutions that drive efficiency and innovation.
            </p>
            <p className="mt-4 text-lg text-gray-300">
              From AI-driven chatbots to advanced analytics, we help businesses harness the full potential of artificial intelligence.
            </p>
          </motion.div>
        </div>
      </section>

      {/* AI Services Section */}
      <section className="text-center py-16 md:py-24">
        <motion.h1
          className="text-4xl"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Services We Provide
        </motion.h1>
        <motion.p
          className="mt-4 text-lg text-gray-300 max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Our AI-powered services enhance efficiency and accuracy across industries.
        </motion.p>

        {/* Services Grid (Fully Responsive) */}
        <div className="container mx-auto px-6 md:px-16 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="rounded-2xl overflow-hidden bg-black shadow-lg transition-transform duration-300 hover:scale-105"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              {/* Image Section */}
              <div className="w-full h-72 md:h-80 rounded-t-2xl overflow-hidden">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
              </div>

              {/* Content Section */}
              <div className="bg-black p-6 text-left rounded-b-2xl">
                <h3 className="text-2xl text-white">{service.title}</h3>
                <p className="mt-2 text-gray-300">{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;


// import React from "react";
// import { motion } from "framer-motion";

// const About = () => {
//   const services = [
//     {
//       title: "AI Agents",
//       description: "Intelligent AI-powered virtual agents.",
//       image: "/assets/img2.jpg",
//       // gradient: "bg-gradient-to-br from-purple-500 via-blue-500 to-pink-500",
//     },
//     {
//       title: "Chatbots",
//       description: "Engage with automated AI-driven responses.",
//       image: "/assets/explore.webp",
//       // gradient: "bg-gradient-to-br from-yellow-500 via-orange-500 to-red-500",
//     },
//     {
//       title: "Face Recognition",
//       description: "Advanced AI for facial analysis and identity verification.",
//       image: "/assets/img1.webp",
//       // gradient: "bg-gradient-to-br from-teal-400 via-blue-500 to-indigo-600",
//     },
//     {
//       title: "OCR",
//       description: "Extract text from images and scanned documents.",
//       image: "/assets/img3.jpg",
//       // gradient: "bg-gradient-to-br from-pink-400 via-red-500 to-yellow-500",
//     },
//     {
//       title: "Language Translation",
//       description: "Seamless multilingual translations powered by AI.",
//       image: "/assets/img4.jpg",
//       // gradient: "bg-gradient-to-br from-green-400 via-teal-500 to-blue-600",
//     },
//     {
//       title: "Sentiment Analysis",
//       description: "Analyze emotions in text and user interactions.",
//       image: "/assets/img7.avif",
//       // gradient: "bg-gradient-to-br from-gray-700 via-gray-900 to-black",
//     },
//   ];
  
//   return (
//     <div className="bg-black text-white min-h-screen">
//       {/* Hero Section */}
//       <section className="text-center py-24">
//         <motion.h1
//           className="text-5xl mt-2"
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//         >
//           About
//         </motion.h1>
//         <motion.p
//           className="mt-6 text-lg text-gray-300 max-w-3xl mx-auto"
//           initial={{ opacity: 0, y: 10 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//         >
//           neUro Ki is a one stop AI utility platform offering powerful tools for automation data analysis and AI driven solutions. From chatbots to deep learning models it simplifies AI for enhanced productivity and innovation all in one place.
//         </motion.p>
//       </section>

// <section className="container mx-auto px-6 md:px-16 py-24 flex flex-col space-y-16">
//   {/* First Block: Text on Left, Large Image on Right */}
//   <div className="flex flex-col md:flex-row items-center justify-between space-y-12 md:space-y-0">
//     {/* Left Content */}
//     <motion.div
//       className="md:w-1/2 pr-10"
//       initial={{ opacity: 0, x: -50 }}
//       animate={{ opacity: 1, x: 0 }}
//       transition={{ duration: 1 }}
//     >
//       <h3 className="text-3xl md:text-4xl">Our vision for the future of AI</h3>
//       <p className="mt-6 text-lg text-gray-300">
//       Our mission is to make AI accessible and impactful for everyone. We strive to develop intelligent systems that enhance productivity, align with human values, and drive innovation across industries
//       </p>
    
//     </motion.div>

//     {/* Right: Large Image */}
//     <motion.div
//   className="md:w-1/2 md:pl-10 md:h-3/4 relative" 
//   initial={{ opacity: 0, x: 50 }}
//   animate={{ opacity: 1, x: 0 }}
//   transition={{ duration: 1 }}
// >
//   <img
//     src="/assets/explore.webp"
//     alt="AI Vision"
//     className="rounded-3xl w-full h-[600px] object-cover shadow-xl"
//   />
// </motion.div>
//   </div>

//   {/* Second Block: Image on Left, Text on Right */}
//   <div className="flex flex-col md:flex-row items-center justify-between space-y-12 md:space-y-0 md:space-x-12">
//     {/* Left: Image Below */}
//     <motion.div
//       className="md:w-1/2 md:pl-10 md:h-3/4 relative"
//       initial={{ opacity: 0, x: -50 }}
//       animate={{ opacity: 1, x: 0 }}
//       transition={{ duration: 1 }}
//     >
//       <img
//         src="/assets/img2.jpg"
//         alt="AI Innovation"
//         className="rounded-3xl w-full h-full object-cover shadow-xl"
//       />
//     </motion.div>

//     {/* Right Content */}
//     <motion.div
//       className="md:w-1/2 pl-10"
//       initial={{ opacity: 0, x: 50 }}
//       animate={{ opacity: 1, x: 0 }}
//       transition={{ duration: 1 }}
//     >
//       <h3 className="text-3xl md:text-4xl ">The impact of AI on industries</h3>
//       <p className="mt-6 text-lg text-gray-300">
//         AI is transforming industries by automating tasks, enhancing decision-making,
//         and improving customer experiences. At neUro Ki, we create cutting-edge
//         AI solutions that drive efficiency and innovation.
//       </p>
//       <p className="mt-4 text-lg text-gray-300">
//         From AI-driven chatbots to advanced analytics, we help businesses harness the
//         full potential of artificial intelligence.
//       </p>
//     </motion.div>
//   </div>
// </section>

//       {/* Services Section */}
//       <section className="text-center py-24">
//   {/* Title */}
//   <motion.p
//     className="text-4xl"
//     initial={{ opacity: 0, y: -20 }}
//     animate={{ opacity: 1, y: 0 }}
//     transition={{ duration: 1 }}
//   >
//     Services We Provide
//   </motion.p>
//   <motion.p
//     className="mt-4 text-lg text-gray-300 max-w-3xl mx-auto"
//     initial={{ opacity: 0, y: 10 }}
//     animate={{ opacity: 1, y: 0 }}
//     transition={{ duration: 1 }}
//   >
//     Our AI-powered services are built to enhance efficiency and accuracy across industries.
//   </motion.p>

//   {/* Services Grid */}
//   <div className="container mx-auto px-6 md:px-16 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
//     {services.map((service, index) => (
//       <motion.div
//         key={index}
//         className="rounded-2xl overflow-hidden bg-black shadow-lg transition-transform duration-300 hover:scale-105"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8, delay: index * 0.2 }}
//       >
//         {/* Image Section */}
//         <div className="w-full h-60 rounded-t-2xl overflow-hidden">
//           <img
//             src={service.image}
//             alt={service.title}
//             className="w-full h-full object-cover"
//           />
//         </div>

//         {/* Content Section (Separate) */}
//         <div className="bg-black p-6 text-left rounded-b-2xl">
//           <h3 className="text-2xl text-white">{service.title}</h3>
//           <p className="mt-2 text-gray-300">{service.description}</p>
//         </div>
//       </motion.div>
//     ))}
//   </div>
// </section>
//     </div>
//   );
// };

// export default About;


// import React from "react";
// import { motion } from "framer-motion";

// const About = () => {
//   return (
//     <div className="bg-black text-white min-h-screen">
//       {/* Hero Section */}
//       <section className="text-center py-24">
//         <motion.h3
//           className="text-gray-400 text-lg"
//           initial={{ opacity: 0, y: -10 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//         >
//           Company
//         </motion.h3>
//         <motion.h1
//           className="text-5xl font-bold mt-2"
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//         >
//           About
//         </motion.h1>
//         <motion.p
//           className="mt-6 text-lg text-gray-300 max-w-3xl mx-auto"
//           initial={{ opacity: 0, y: 10 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//         >
//           Neuroline Ki is an advanced AI research and deployment company. Our
//           mission is to build intelligent systems that enhance productivity and
//           create meaningful impact.
//         </motion.p>
//       </section>

//       {/* Content Section */}
//       <section className="container mx-auto px-6 md:px-16 py-24 flex flex-col md:flex-row items-center justify-between space-y-10 md:space-y-0">
//         {/* Left Content */}
//         <div className="md:w-1/2">
//           <motion.h2
//             className="text-3xl md:text-4xl font-bold"
//             initial={{ opacity: 0, x: -50 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 1 }}
//           >
//             Our vision for the future of AI
//           </motion.h2>
//           <motion.p
//             className="mt-6 text-lg text-gray-300"
//             initial={{ opacity: 0, x: -50 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 1, delay: 0.2 }}
//           >
//             Our mission is to ensure that artificial general intelligence (AGI)
//             benefits all of humanity. AI systems that are generally smarter than
//             humans should be aligned with our collective values and ethics.
//           </motion.p>

//           {/* CTA Buttons */}
//           <motion.div
//             className="mt-8 flex space-x-4"
//             initial={{ opacity: 0, x: -50 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 1, delay: 0.4 }}
//           >
//             <button className="bg-gray-700 text-white px-6 py-3 rounded-full hover:bg-gray-600 transition">
//               Our Plan for AI
//             </button>
//             <button className="border border-gray-600 px-6 py-3 rounded-full text-white hover:bg-gray-800 transition">
//               Our Charter →
//             </button>
//           </motion.div>
//         </div>

//         {/* Right Image */}
//         <motion.div
//           className="md:w-1/2 rounded-3xl overflow-hidden shadow-xl"
//           initial={{ opacity: 0, x: 50 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 1 }}
//         >
//           <img
//             src="/assets/explore.webp"
//             alt="AI Vision"
//             className="rounded-3xl w-full object-cover"
//           />
//         </motion.div>
//       </section>
//     </div>
//   );
// };

// export default About;


// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../components/SideBar";


// const About = () => {
//   const navigate = useNavigate();
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const cards = [
//     {
//       title: "Text Extraction",
//       description: "Extract meaningful information from scanned documents and images.",
//       image: "/assets/ai-text-extraction.jpg",
//     },
//     {
//       title: "Object Detection",
//       description: "Identify and classify objects in images and videos.",
//       image: "/assets/ai-object-detection.webp",
//     },
//     {
//       title: "Natural Language Processing",
//       description: "Analyze and understand human language to provide intelligent responses.",
//       image: "/assets/ai-nlp.jpg",
//     },
//     {
//       title: "Image Recognition",
//       description: "Recognize faces, patterns, and more with advanced AI algorithms.",
//       image: "/assets/ai-image-recognition.jpg",
//     },
//     {
//       title: "Predictive Analytics",
//       description: "Forecast trends and behaviors to make data-driven decisions.",
//       image: "/assets/ai-predictive-analytics.jpg",
//     },
//     {
//       title: "AI-Powered Chatbots",
//       description: "Engage customers with real-time intelligent conversations.",
//       image: "/assets/ai-chatbots.jpg",
//     },
//   ];

//   const staggeredCardStyles = [
//     { width: "300px", height: "400px", marginTop: "40px", zIndex: 2 },
//     { width: "350px", height: "450px", marginTop: "0px", zIndex: 3 },
//     { width: "250px", height: "350px", marginTop: "80px", zIndex: 1 },
//   ];

//   const statistics = [
//     { title: "1M+", subtitle: "Documents Processed" },
//     { title: "500K+", subtitle: "Objects Detected" },
//     { title: "99.9%", subtitle: "Accuracy Achieved" },
//     { title: "250+", subtitle: "Businesses Empowered" },
//   ];

//   const testimonials = [
//     {
//       name: "John Doe",
//       role: "CEO, TechCorp",
//       feedback: "Neuroline's AI tools revolutionized the way we handle data and improved efficiency by 80%.",
//     },
//     {
//       name: "Jane Smith",
//       role: "Data Scientist, InnovateAI",
//       feedback: "The predictive analytics and NLP capabilities are top-notch and incredibly easy to use.",
//     },
//   ];

//   return (
//     <div className="flex min-h-screen bg-black text-white transition-all duration-300">
//       {/* Sidebar */}
//       <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
//     {/* <div
//       className="relative min-h-screen overflow-hidden"
      
//       style={{
//         background: `radial-gradient(circle at 30% 50%, #a8edea, #fed6e3)`,
//       }}
//     > */}
//     <div
//         className={`flex flex-col flex-grow transition-all duration-300 overflow-hidden ${
//           isSidebarOpen ? "pl-64" : "pl-20"
//         }`}
//       >
//         <main className="flex-1 w-full max-w-screen-xl mx-auto px-6">
//           <div
//             className="relative min-h-screen overflow-hidden"
//             style={{
//               background:"bg-black",
//             }}
//           >
//       {/* Header */}
//       <div className="relative text-center py-32">
//         <motion.h1
//           className="text-5xl md:text-6xl font-bold text-white drop-shadow-lg"
//           initial={{ opacity: 0, y: -50 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//         >
//           Unlock the Power of <span className="text-blue-500">AI</span>
//         </motion.h1>
//         <motion.p
//           className="mt-6 text-gray-700 text-lg"
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, delay: 0.5 }}
//         >
//           Explore our innovative AI tools designed to enhance your workflows and transform your ideas
//           into reality.
//         </motion.p>
//       </div>

//       <div className="relative px-6 py-16">
//         <div
//           className="flex flex-wrap justify-center items-start gap-10"
//           style={{ perspective: "1000px" }}
//         >
//           {cards.map((card, index) => {
//             const style = staggeredCardStyles[index % staggeredCardStyles.length];

//             return (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 50 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 whileHover={{
//                   scale: 1.1,
//                   rotateY: 5,
//                   zIndex: 10,
//                   transition: { duration: 0.3 },
//                 }}
//                 transition={{ delay: index * 0.1, duration: 0.5 }}
//                 style={{
//                   ...style,
//                   backgroundImage: `url(${card.image})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                   borderRadius: "15px",
//                   boxShadow: "0 10px 20px rgba(0, 0, 0, 0.3)",
//                   cursor: "pointer",
//                   position: "relative",
//                 }}
//               >
//                 <motion.div
//                   initial={{ opacity: 0 }}
//                   whileHover={{ opacity: 1 }}
//                   transition={{ duration: 0.3 }}
//                   style={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     width: "100%",
//                     height: "100%",
//                     backgroundColor: "rgba(0, 0, 0, 0.6)",
//                     borderRadius: "15px",
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     color: "white",
//                     padding: "20px",
//                   }}
//                 >
//                   <h3
//                     className="text-xl font-bold mb-4"
//                     style={{ textAlign: "center" }}
//                   >
//                     {card.title}
//                   </h3>
//                   <p
//                     className="text-sm"
//                     style={{ textAlign: "center", lineHeight: "1.5" }}
//                   >
//                     {card.description}
//                   </p>
//                 </motion.div>
//               </motion.div>
//             );
//           })}
//         </div>
//       </div>

//       <div className="text-gray-400 py-16">
//         <h2 className="text-center text-3xl font-bold mb-10">Our Impact</h2>
//         <div className="flex flex-wrap justify-center items-center gap-10">
//           {statistics.map((stat, index) => (
//             <div key={index} className="text-center">
//               <h3 className="text-4xl font-bold">{stat.title}</h3>
//               <p className="text-gray-600">{stat.subtitle}</p>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className=" py-16">
//         <h2 className="text-center text-3xl font-bold mb-10">Why Choose Us</h2>
//         <div className="flex flex-wrap justify-center items-start gap-10 px-8">
//           {[
//             {
//               title: "Expertise",
//               description: "We bring years of AI and data expertise to solve your toughest challenges.",
//               icon: "/assets/expertise-icon.avif",
//             },
//             {
//               title: "Scalability",
//               description: "Our tools scale with your needs, whether you're a startup or enterprise.",
//               icon: "/assets/scalability-icon.jpg",
//             },
//             {
//               title: "Innovation",
//               description: "We deliver cutting-edge solutions tailored to your business goals.",
//               icon: "/assets/innovation-icon.webp",
//             },
//           ].map((item, index) => (
//             <div key={index} className="flex flex-col items-center max-w-xs text-center">
//               <img src={item.icon} alt={item.title} className="w-16 h-16 mb-4" />
//               <h3 className="text-xl font-bold">{item.title}</h3>
//               <p className="text-gray-600">{item.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="py-16">
//         <h2 className="text-center text-3xl font-bold mb-10">How It Works</h2>
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-10 px-8">
//           {[
//             {
//               step: "1",
//               title: "Analyze Your Needs",
//               description: "We start by understanding your business and identifying key challenges.",
//             },
//             {
//               step: "2",
//               title: "Design the Solution",
//               description: "We develop a tailored AI solution to meet your specific requirements.",
//             },
//             {
//               step: "3",
//               title: "Deploy and Optimize",
//               description: "We implement the solution and ensure seamless integration into your workflows.",
//             },
//           ].map((item, index) => (
//             <div key={index} className="bg-black shadow-lg rounded-lg p-6 text-center">
//               <div className="text-4xl font-bold text-blue-500">{item.step}</div>
//               <h3 className="text-xl font-bold mt-4">{item.title}</h3>
//               <p className="text-gray-600 mt-2">{item.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className=" py-16">
//         <h2 className="text-center text-3xl font-bold mb-10">Frequently Asked Questions</h2>
//         <div className="max-w-4xl mx-auto space-y-6">
//           {[
//             {
//               question: "How can AI improve my business processes?",
//               answer: "AI can automate repetitive tasks, provide insights from data, and help make data-driven decisions faster.",
//             },
//             {
//               question: "Is your AI platform suitable for small businesses?",
//               answer: "Absolutely! Our solutions are designed to scale based on your business size and requirements.",
//             },
//             {
//               question: "What industries do you cater to?",
//               answer: "We cater to a wide range of industries including healthcare, finance, retail, logistics, and more.",
//             },
//           ].map((faq, index) => (
//             <div key={index} className="bg-black shadow-md rounded-lg p-6">
//               <h3 className="text-lg font-bold mb-2">{faq.question}</h3>
//               <p className="text-gray-600">{faq.answer}</p>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="text-center py-16">
//         <motion.h2
//           className="md:text-4xl text-white mb-6"
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//         >
//           Ready to Explore AI Tools?
//         </motion.h2>
//         <motion.button
//           className="px-8 py-4 bg-gray-500 text-white font-bold rounded-full shadow-lg hover:bg-blue-600 transition-all"
//           whileHover={{ scale: 1.1 }}
//           onClick={() => navigate("/services")} 
//         >
//           Discover More
//         </motion.button>
//       </div>

//     </div>
//     </main>
//       </div>
//     </div>
//   );
// };

// export default About;

